import React from 'react';
import { Skeleton } from '@material-ui/lab';

import BaseSkeleton from '../BaseSkeleton';

import { StripSkeletonProps } from './StripSkeleton.types';

const StripSkeleton: React.FC<StripSkeletonProps> = ({ height, width }) => {
  return (
    <div className="width-100 flex primary-light-background">
       <Skeleton
                width={12}
                height={12}
                variant="circle"
                className="mt2 ml2"
              />
      <BaseSkeleton  width={width} height={height} className='my1 ml2'/>
    </div>
  );
};

StripSkeleton.defaultProps = {
  width: 300,
  height: 15,
};

export default StripSkeleton;
export { StripSkeletonProps };
